import ListsForSignedInUsersModal from '@/components/modals/ListsForSignedInUsersModal.vue';

import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { isProOnboardingExperimentEnabled } from '@/helpers/pro-web-helper';
import { useI18n } from '@/helpers/composables/useI18n';

import { AccountModal } from '@/lazy-load-components';
import { AccountModes } from '@/enums/login';
import { SnowplowContext } from './tracking/providers';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useUserStore } from '@/stores/pinia/useUserStore';
// EXP_JW_PRO_PRICING
import { useExperiment } from '@/libraries/experiment';
// EXP_JW_PRO_PRICING

export function preventNonSignedInAction(
	modalType?: keyof typeof AccountModes,
	additionalContexts?: SnowplowContext[]
) {
	const { webLocale } = storeToRefs(useLanguageStore());
	const { isPremium } = storeToRefs(useUserStore());
	const userStore = useUserStore();

	const { tc } = useI18n();

	const hasProOnboardingEnabled = !isPremium.value && isProOnboardingExperimentEnabled(webLocale.value);

	if (!userStore.isLoggedIn) {
		// EXP_JW_PRO_PRICING: bucketed signed-out users always see the account modal (sign in / upgrade
		// to pro) — the same modal LoginButton.vue opens — regardless of what this call site would
		// otherwise show. Raw bucket assignment (not activeVariant) since callers may run outside any
		// component scope with an active ProModal placement.
		const { experimentInfo: pricingExpInfo } = useExperiment('EXP_JW_PRO_PRICING');
		if (pricingExpInfo.value?.variant) {
			ModalHelper.openModal(AccountModal, { closable: true }, { cssClass: 'login-modal' });
			return true;
		}
		// EXP_JW_PRO_PRICING

		if (hasProOnboardingEnabled) {
			ModalHelper.openModal(
				AccountModal,
				{ closable: true, startScreen: AccountModes.REGISTRATION_OPTIONS },
				{ cssClass: 'account-modal' },
				'FreemiumSignUpModal',
				false,
				additionalContexts
			);

			return true;
		}

		if (modalType) {
			ModalHelper.openModal(
				AccountModal,
				{ closable: true, startScreen: AccountModes[modalType] },
				{ cssClass: 'account-modal' },
				'FreemiumSignUpModal',
				false,
				additionalContexts
			);
		} else {
			ModalHelper.openModal(
				ListsForSignedInUsersModal,
				{
					closable: true,
					header: tc('WEBAPP_YOUNOWNEEDANACCOUNTFORLISTSHEADER'),
					body: tc('WEBAPP_YOUNOWNEEDANACCOUNTFORLISTSBODY'),
				},
				{ cssClass: 'lists-for-signed-in-users-modal' }
			);
		}

		return true;
	}

	return false;
}
